import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Thumbs, FreeMode, Navigation } from 'swiper';
import 'swiper/css/bundle';
import FullscreenImageSlider from '../FullscreenImageSlider';
import clsx from 'clsx';
import ResponsiveImage from '../ResponsiveImage';
import Icon from '../Icon';
import { translate } from '../../Services/translation';

const prevElementId = 'swiper-prev-el';
const nextElementId = 'swiper-next-el';

const ProductPageImageSlider = ({ images }) => {
  const [swiper, setSwiper] = useState();
  const [fullscreenOpen, setFullscreenOpen] = useState(false);
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const [rendered, setRendered] = useState(false);

  useEffect(() => setRendered(true), []);

  return (
    <>
      {!rendered && images?.length > 0 && (
        <div className="swiper__placeholder">
          <ResponsiveImage {...images[0]?.image} />
        </div>
      )}
      {rendered && images?.length > 0 && (
        <div className="swiper__wrapper">
          <button
            className="swiper__fullscreen-toggle"
            onClick={() => setFullscreenOpen(true)}
            aria-label={translate('product.image.open-fullscreen.sc')}
          >
            <Icon
              name="Expand"
              className="swiper__fullscreen-toggle-icon"
              size={24}
            />
          </button>
          <button
            className="swiper-button-prev"
            id={prevElementId}
            aria-label={translate('product.image.previous.sc')}
          >
            <Icon name="Caret-Left" className="icon" size={24} />
          </button>
          <Swiper
            pagination={{
              type: 'fraction',
            }}
            navigation={{
              enabled: true,
              prevEl: `#${prevElementId}`,
              nextEl: `#${nextElementId}`,
            }}
            modules={[FreeMode, Pagination, Navigation, Thumbs]}
            loop={true}
            slidesPerView={1}
            className="swiper-container-main"
            onSlideChange={(swiper) => setActiveSlideIndex(swiper.realIndex)}
            onSwiper={(swiper) => setSwiper(swiper)}
          >
            {images.map((image, index) => (
              <SwiperSlide key={index}>
                <div className="swiper__slide">
                  <ResponsiveImage
                    {...image.image}
                    onClick={() => setFullscreenOpen(true)}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <button
            className="swiper-button-next"
            id={nextElementId}
            aria-label={translate('product.image.next.sc')}
          >
            <Icon name="Caret-Right" className="icon" size={24} />
          </button>
          {images.length > 1 && (
            <div className="swiper__thumbnails-wrapper">
              <div className="swiper__thumbnails">
                {images.map((image, index) => (
                  <button
                    className={clsx(
                      'swiper__thumbnail',
                      activeSlideIndex == index ? 'active' : ''
                    )}
                    key={image.thumbnailSrc + index}
                    onClick={() => swiper?.slideTo(index + 1)}
                    aria-label={translate(
                      activeSlideIndex == index
                        ? 'product.image-thumbnail.active.sc'
                        : 'product.image-thumbnail.slide-to.sc'
                    )}
                  >
                    <img
                      src={image.thumbnailSrc}
                      alt={image.alt}
                      itemProp="image"
                    />
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
      {fullscreenOpen && (
        <FullscreenImageSlider
          images={images}
          onClosed={() => setFullscreenOpen(false)}
          initialSlide={activeSlideIndex}
        />
      )}
    </>
  );
};

export default ProductPageImageSlider;
